/**
 * OmniLight3D semantic rules. linterParser.ts validates the format.
 */
import { ruleRegistry } from '../../../../linter/RuleRegistry.js';
import { armEmits } from '../../../../linter/ruleArms.js';
import { projectorArm, projectorWithoutShadowDiagnostic } from '../shared/linterChecks.js';
const arms = {
    projectorWithoutShadow: projectorArm('omnilight3d'),
};
/**
 * light_3d.cpp:623-625: `light_projector` set while `shadow_enabled` is not true.
 * No range advisory: `omni_range` and `light_energy` floors are validator bounds
 * (light_3d.cpp:639, :389), and `omni_attenuation` (light_3d.cpp:640) is open at both ends.
 */
function checkOmniLight3D(context) {
    const { node } = context;
    const projectorDiagnostic = projectorWithoutShadowDiagnostic(node, arms.projectorWithoutShadow);
    return projectorDiagnostic ? [projectorDiagnostic] : [];
}
const omniLight3DValidationRule = {
    meta: {
        name: 'valid-omnilight3d-properties',
        description: 'Validates OmniLight3D property values against the ranges the editor accepts',
        category: 'validation',
        applicableNodeTypes: ['OmniLight3D'],
        emits: armEmits(arms),
    },
    check: checkOmniLight3D,
};
ruleRegistry.register(omniLight3DValidationRule);
//# sourceMappingURL=linter.js.map